<div class="flex flex-col gap-1 w-full">
	<div class="flex gap-[2px]">
		<label [for]="label">{{title}}</label>
		<label class="text-red-600 font-semibold" *ngIf="required">*</label>
	</div>
	<ng-content></ng-content>
</div>